import React from 'react';
import styled from 'styled-components';
import { IonHeader, IonToolbar } from '@ionic/react';

const StyledHeader = styled(IonHeader)``;

const StyledToolbar = styled(IonToolbar)`
  --padding-top: 0;
  --padding-bottom: 0;
  --min-height: 60px;
`;

interface AppHeaderProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const AppHeader: React.FC<AppHeaderProps> = ({ children, style, className }) => (
  <StyledHeader style={style} className={className}>
    <StyledToolbar>{children}</StyledToolbar>
  </StyledHeader>
);

export default AppHeader;
